import actionCreatorFactory from 'typescript-fsa';
// import { InferenceResultObsrec } from '../../../models/InferenceResultObsrec';
// import { InferenceAdditionalResultObsrec } from '../../../models/InferenceAdditionalResultObsrec';
// actionのprefixを設定
const actionCreator = actionCreatorFactory('inference');

const execute = actionCreator.async<
  {
    imageStr: string
  }, // started: parameter type
  {
    // results: InferenceResultObsrec[];
    // additionalResult: InferenceAdditionalResultObsrec;
    croppedImage: {
      bucket: string;
      key: string;
    }
  }, // done: success type
  {
    error: string
  } // failed: error type
  >('EXECUTE');

const reset = actionCreator('RESET');

export {
  execute,
  reset
};



// WEBPACK FOOTER //
// ./src/redux/modules/inferenceObsrec/actions.ts